import React, { useEffect } from "react";
import { renderToStaticMarkup } from "react-dom/server";
import closeIcon from "../../img/icons/close-m.svg";
import "./style.css";

const TRIGGER_FORM_AFTER_SECONDS_PASSED = 30;

/**
 * Qualtrics form events on load of the page.
 * @returns null
 */
const QualtricsFeedbackForm = () => {
  useEffect(() => {
    const handleLoad = () => {
      // check for qualtrics form.
      const qsiElement = document.querySelector(
        "#qualtrics-page-feedback-survey"
      );
      if (!qsiElement && !qsiElement.hasChildNodes()) {
        return;
      }

      // create a close btn and add to qsiElement
      let closeBtn = document.createElement("a");
      const img = <img src={closeIcon} alt="close" />;
      closeBtn.innerHTML = renderToStaticMarkup(img);
      closeBtn.classList = "close-btn";
      qsiElement.prepend(closeBtn);

      // adding close btn event.
      closeBtn.addEventListener("click", () => {
        qsiElement.classList.remove("showing");
      });

      // load form.
      setTimeout(() => {
        qsiElement.classList.add("showing");
      }, TRIGGER_FORM_AFTER_SECONDS_PASSED * 1000);
    };

    // Add the load event listener
    window.addEventListener("load", handleLoad);

    // Cleanup function to remove the event listener
    return () => {
      window.removeEventListener("load", handleLoad);
    };
  }, []);

  return null;
};

export default QualtricsFeedbackForm;
